window.sectionAbout = {
	init: () => {
		sectionAbout.actionWithInfoBlock();
		sectionAbout.actionWithTheReviewsBlock();
	},

	actionWithInfoBlock: () => {
		const linksArea = document.querySelectorAll('.aboutInfoLink');
		const images = document.querySelectorAll('.aboutInfoImg');
		let dictionary = {};

		if (linksArea) {
			linksArea.forEach((link) => {
				link.addEventListener('mouseenter', () => {
					if(link.classList.contains('active')) {
						return
					}

					images.forEach((el, index, arr) => {
						dictionary[el.getAttribute('src')] = el;
						el.classList.remove('active');
					});

					for (let item of linksArea) {
						item.classList.remove('active');
					}

					link.classList.add('active');
					dictionary[link.getAttribute('data-src')].classList.add('active');
				})
			})
		}
	},

	actionWithTheReviewsBlock: (init = true) => {
		let container = document.querySelector('.vg-page-about .reviews-area');

		if(!container) {
			return;
		}

		// window.addEventListener('resize', () => {
		// 	if(window.innerWidth <= 991) {
		// 		init = false;
		// 	}
		// 	if(init === true) {
		// 		init = false;
		// 		sectionAbout.actionWithTheReviewsBlock();
		// 	}
		// });
		//
		// if(window.innerWidth <= 991) {
		// 	return;
		// }

		let lists = container.querySelectorAll('.list-item');
		lists.forEach((list, index) => {
			list.style.transitionDelay = `${(index / 10) * 4}s`;
		});

		let num = 0;
		let blockContactShowed = false;

		window.addEventListener('scroll', function () {
			if (blockContactShowed === false && visibleSection(container, 'top')) {
				num += 1;
				let listContainer = container.querySelector('.vg-contacts-list .list');
				if (num > 20) {
					listContainer.classList.add('active');
					blockContactShowed = true;
				}
			}
		});
	}
};

sectionAbout.init();